import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-lg-6 col-xxl-4" }
const _hoisted_3 = { class: "col-12 col-lg-6 col-xxl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_ProfileAnagraph = _resolveComponent("ProfileAnagraph")!
  const _component_ProfileCenters = _resolveComponent("ProfileCenters")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.$t('page.profile')
    }, null, 8 /* PROPS */, ["page"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ProfileAnagraph)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ProfileCenters)
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}